
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4b75"];
var parcelRegister = parcelRequire.register;
parcelRegister("5GcFk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ADVENT_CALENDAR_SLUG", function () { return $f1cfae56f516caf1$export$27814413603ae60c; });
$parcel$export(module.exports, "default", function () { return $f1cfae56f516caf1$export$2e2bcd8739ae039; });

var $7YWoO = parcelRequire("7YWoO");

var $lp3dk = parcelRequire("lp3dk");

var $im5sL = parcelRequire("im5sL");

var $9AGLN = parcelRequire("9AGLN");
var $3lzdj = parcelRequire("3lzdj");
var $1Q5Iy = parcelRequire("1Q5Iy");

var $dvPqk = parcelRequire("dvPqk");

var $88FA0 = parcelRequire("88FA0");

var $duLFK = parcelRequire("duLFK");

var $195xf = parcelRequire("195xf");

var $iVdQg = parcelRequire("iVdQg");

var $bcbvQ = parcelRequire("bcbvQ");

var $jlTfJ = parcelRequire("jlTfJ");

var $i6TQx = parcelRequire("i6TQx");

var $4r4cM = parcelRequire("4r4cM");

var $6pY3b = parcelRequire("6pY3b");

var $1qZrx = parcelRequire("1qZrx");

var $lrIVV = parcelRequire("lrIVV");

var $cZSqT = parcelRequire("cZSqT");
const $f1cfae56f516caf1$export$27814413603ae60c = "julekalender";

const $f1cfae56f516caf1$var$calendarFooterImage = new URL((parcelRequire("7SoHX"))).toString();
const $f1cfae56f516caf1$var$mainSignupCode = "julekalender-2024-hovedpamelding";
const $f1cfae56f516caf1$var$ContestInfoBox = ()=>{
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cZSqT.default), {
        theme: "christmas",
        title: "Vinn premier hver dag",
        className: "tw-text-center",
        children: /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-items-center tw-gap-4",
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                    children: "Delta i julekalenderen og bli med i trekningen av spennende premier!"
                }),
                " ",
                /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                    children: "For hver dag du deltar f\xe5r du ogs\xe5 et lodd til hovedtrekningen p\xe5 julaften. Jo flere dager du deltar, desto st\xf8rre vinnersjanse."
                }),
                /*#__PURE__*/ (0, $7YWoO.jsxs)("div", {
                    className: "tw-flex tw-flex-row tw-justify-center tw-gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                            variant: "inverted",
                            href: "/julekalender/vinnere",
                            children: "Se vinnere"
                        }),
                        /*#__PURE__*/ (0, $7YWoO.jsx)((0, $im5sL.default), {})
                    ]
                })
            ]
        })
    });
};
const $f1cfae56f516caf1$var$TermsAndConditionsLinks = ()=>/*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.InternalLink), {
                href: "/julekalender/vilkar",
                variant: "inverted",
                children: "vilk\xe5rene"
            }),
            " ",
            "og",
            " ",
            /*#__PURE__*/ (0, $7YWoO.jsx)((0, $6pY3b.ExternalLink), {
                variant: "inverted",
                href: "https://www.tine.no/kontakt/artikler/ansvarserkl%C3%A6ring-personvern-og-debattregler-p%C3%A5-tines-nettsteder",
                children: "personvernerkl\xe6ringen"
            }),
            "."
        ]
    });
const $f1cfae56f516caf1$var$ContestFormBox = (0, $lp3dk.view)(()=>{
    const [consent, setConsent] = (0, $dvPqk.useState)(false);
    const company = (0, $bcbvQ.default).getCurrentCompany();
    const isSignedUp = (0, $i6TQx.default).isSignedUpTo($f1cfae56f516caf1$var$mainSignupCode);
    const isLoggedIn = (0, $bcbvQ.default).isLoggedIn();
    const values = {
        company: company?.customerNumber || "",
        description: "Julekalender 2024 - hovedp\xe5melding"
    };
    const companyName = company?.name || "Ditt selskap";
    const handleSignup = (payload)=>{
        (0, $i6TQx.default).signUpToPromotion($f1cfae56f516caf1$var$mainSignupCode, "", "", payload);
    };
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $cZSqT.default), {
        theme: "christmas",
        title: isLoggedIn && isSignedUp ? "Hovedtrekningen" : "Meld deg p\xe5 hovedtrekningen",
        className: "tw-text-center",
        children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
            className: "tw-flex tw-flex-col tw-gap-3",
            children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                        children: [
                            isLoggedIn && isSignedUp ? `${companyName} er` : "Bli",
                            " med i trekningen av gavekort p\xe5 kr 5000,- til sosialkassen."
                        ]
                    }),
                    !isLoggedIn ? /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                                children: [
                                    "Mer informasjon finnes i ",
                                    /*#__PURE__*/ (0, $7YWoO.jsx)($f1cfae56f516caf1$var$TermsAndConditionsLinks, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                children: "Du m\xe5 logge inn for \xe5 delta."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $7YWoO.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)("p", {
                                className: "tw-mb-0.5",
                                children: "\xd8k din vinnersjanse ved \xe5:"
                            }),
                            /*#__PURE__*/ (0, $7YWoO.jsxs)("ul", {
                                className: "tw-text-left",
                                children: [
                                    /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                        children: "Melde deg p\xe5 hovedtrekningen f\xf8r 1. desember for 2 lodd, eller fra og med 1. desember for 1 lodd"
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                        children: "Delta i dagens kalenderluke for 1 lodd per dag"
                                    }),
                                    /*#__PURE__*/ (0, $7YWoO.jsx)("li", {
                                        children: "F\xf8lge TINE Partner p\xe5 Instagram for 1 lodd"
                                    })
                                ]
                            }),
                            " "
                        ]
                    }),
                    isLoggedIn && (!isSignedUp ? /*#__PURE__*/ (0, $7YWoO.jsx)((0, $iVdQg.default), {
                        buttonText: "Delta i trekningen",
                        config: (0, $195xf.getCaptureConfig)("main"),
                        mappings: (0, $195xf.getCaptureMappings)("main"),
                        onSignup: handleSignup,
                        values: values,
                        disabled: !consent,
                        buttonVariant: "secondary",
                        trackingFormName: "Hovedp\xe5melding julekalender",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $9AGLN.Checkbox), {
                            description: /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                                className: "tw-text-left tw-text-ink-brand-inverted",
                                children: [
                                    "Jeg bekrefter at jeg har lest og forst\xe5tt ",
                                    /*#__PURE__*/ (0, $7YWoO.jsx)($f1cfae56f516caf1$var$TermsAndConditionsLinks, {})
                                ]
                            }),
                            isChecked: consent,
                            onChange: ()=>setConsent(!consent)
                        })
                    }) : /*#__PURE__*/ (0, $7YWoO.jsxs)("p", {
                        children: [
                            "Mer informasjon finnes i ",
                            /*#__PURE__*/ (0, $7YWoO.jsx)($f1cfae56f516caf1$var$TermsAndConditionsLinks, {})
                        ]
                    }))
                ]
            })
        })
    });
});
const $f1cfae56f516caf1$var$AdventCalendarPage = ()=>{
    if ((0, $duLFK.isWaitingForData)((0, $jlTfJ.default).urlData) || (0, $duLFK.isDefaultData)((0, $jlTfJ.default).urlData)) return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $88FA0.default), {
        height: 500
    });
    if ((0, $duLFK.isDataAvailable)((0, $jlTfJ.default).urlData)) {
        const urlData = (0, $jlTfJ.default).urlData.data.find((data)=>data.slug === $f1cfae56f516caf1$export$27814413603ae60c);
        if (!urlData) return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $4r4cM.default), {
            showCloseButton: false,
            gaErrorTracking: {
                context: "advent_calendar_page",
                text: "content_not_found_error"
            },
            children: [
                "Fant ikke innholdet med slug '",
                $f1cfae56f516caf1$export$27814413603ae60c,
                "'"
            ]
        });
        return /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $3lzdj.Grid), {
            cols: 12,
            gap: 4,
            children: [
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                    span: 12,
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $lrIVV.AdventCalendarHeader), {})
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                    span: {
                        base: 12,
                        lg: 4
                    },
                    children: /*#__PURE__*/ (0, $7YWoO.jsxs)((0, $1Q5Iy.Stack), {
                        children: [
                            /*#__PURE__*/ (0, $7YWoO.jsx)($f1cfae56f516caf1$var$ContestInfoBox, {}),
                            /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                                className: "tw-hidden lg:tw-block",
                                children: /*#__PURE__*/ (0, $7YWoO.jsx)($f1cfae56f516caf1$var$ContestFormBox, {})
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                    span: {
                        base: 12,
                        lg: 8
                    },
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)((0, $1qZrx.default), {
                        id: urlData.id
                    })
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                    span: 12,
                    className: "tw-block lg:tw-hidden",
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)($f1cfae56f516caf1$var$ContestFormBox, {})
                }),
                /*#__PURE__*/ (0, $7YWoO.jsx)((0, $3lzdj.Grid).Col, {
                    span: 12,
                    children: /*#__PURE__*/ (0, $7YWoO.jsx)("div", {
                        className: "tw-h-[73px] tw-w-full",
                        children: /*#__PURE__*/ (0, $7YWoO.jsx)("img", {
                            className: "tw-size-full tw-object-cover",
                            src: $f1cfae56f516caf1$var$calendarFooterImage,
                            alt: "Julekalender-footer"
                        })
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7YWoO.jsx)((0, $4r4cM.default), {
        showCloseButton: false,
        gaErrorTracking: {
            context: "advent_calendar_page",
            text: "loading_error"
        },
        children: "Det oppsto en uventet feil under lasting av forsiden"
    });
};
var $f1cfae56f516caf1$export$2e2bcd8739ae039 = (0, $lp3dk.view)($f1cfae56f516caf1$var$AdventCalendarPage);

});
parcelRegister("7SoHX", function(module, exports) {
module.exports = new URL("julekalender_footer.98589ca7.png", import.meta.url).toString();

});



//# sourceMappingURL=AdventCalendarPage.b2d7f456.js.map
